document.addEventListener('DOMContentLoaded', () => {
    const accordionSections = document.querySelectorAll('.accordion_with_image');
    accordionSections.forEach(section => {
        const mainImage = section.querySelector('.content > .image > img');
        if (mainImage) {
            mainImage.style.display = 'none';
        }

        initAccordionWithImage(section);
    });

    const accordions = document.querySelectorAll(".accordion_with_image .accordion");
    const imageContainer = document.querySelector(".accordion_with_image .content-accordion_image img");

    accordions.forEach(acc => {
        acc.querySelector(".accordion_header").addEventListener("click", () => {
            acc.classList.toggle("active");
            const newImage = acc.dataset.image;
            if (newImage && imageContainer) {
                imageContainer.setAttribute("src", newImage);
            }

            accordions.forEach(other => {
                if (other !== acc) other.classList.remove("active");
            });
        });
    });
});

function initAccordionWithImage(section) {
    const sectionId = section.getAttribute('section_id');
    if (!sectionId) return;

    const accordionItems = section.querySelectorAll('.accordion');
    const accordionHeaders = section.querySelectorAll('.accordion_header');
    const mainImage = section.querySelector('.content > .image > img');

    if (accordionItems.length > 0) {
        const firstItem = accordionItems[0];
        const firstHeader = firstItem.querySelector('.accordion_header');
        const firstContent = firstItem.querySelector('.accordion_content');
        const firstImage = firstItem.querySelector('.accordion_content .image img');

        if (firstContent) {
            firstContent.style.maxHeight = firstContent.style.maxHeight = '600px';
            firstHeader.classList.add('active');
            firstHeader.parentNode.classList.add('active');
        }

        // Set main image to the first accordion's image
        if (firstImage && mainImage) {
            // Asignar la fuente de la imagen primero
            mainImage.style.display = 'none';

            mainImage.onload = function () {
                // Mostrar la imagen cuando esté cargada
                mainImage.style.display = 'block';
            };

            mainImage.onerror = function () {
                // Si hay error al cargar, mantener oculta
                mainImage.style.display = 'none';
            };

            // Asignar la fuente de la imagen
            mainImage.src = firstImage.src;
            mainImage.alt = firstImage.alt || '';
        }
    }

    // Add click event to each accordion header
    accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const accordionItem = header.closest('.accordion');
            const content = accordionItem.querySelector('.accordion_content');
            const accordionImage = accordionItem.querySelector('.accordion_content .image img');

            if (!content) return;

            const isOpen = header.classList.contains('active');

            // Close all accordions in this section
            section.querySelectorAll('.accordion_content').forEach(item => {
                item.style.maxHeight = item.style.maxHeight = '0px';
            });

            section.querySelectorAll('.accordion_header').forEach(h => {
                h.classList.remove('active');
            });

            // If the clicked accordion wasn't already open, open it
            if (!isOpen) {
                content.style.maxHeight = content.style.maxHeight = '700px';
                header.classList.add('active');
                
               

                // Update main image
                if (accordionImage && mainImage) {
                    // Ocultar la imagen principal hasta que cargue
                    mainImage.style.display = 'none';

                    mainImage.onload = function () {
                        // Mostrar la imagen cuando esté cargada
                        mainImage.style.display = 'block';
                    };

                    mainImage.onerror = function () {
                        // Si hay error al cargar, mantener oculta
                        mainImage.style.display = 'none';
                    };

                    // Asignar la fuente de la imagen
                    mainImage.src = accordionImage.src;
                    mainImage.alt = accordionImage.alt || '';
                }
            }
        });
    });
}